module.exports = __webpack_public_path__ + "img/rwfb.fb170b95.png";